import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class ClientSubscriptionService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/clientsubscription').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    getSubscriptionTypes(): Observable<ClientSubscriptionType[]> {
        return this.http.get<ClientSubscriptionType[]>(`${this._url}/type`);
    }

    getSubscriptionPage(key: number): Observable<ClientSubscriptionPage[]> {
        const params = new HttpParams().set('clientSubscriptionTypeKey', key.toString());
        return this.http.get<ClientSubscriptionPage[]>(`${this._url}/page`, {
            params: params,
        });
    }

    updateSubscription(modules: ClientSubscriptionForm[]): Observable<any> {
        let data = {
            pages: modules,
        };

        return this.http.post<any>(this._url + '/update', data);
    }

    cloneSubscription(clientSubscriptionTypeKey: number, cloneKey: number): Observable<any> {
        const data = {
            clientSubscriptionTypeKey: clientSubscriptionTypeKey,
            cloneKey: cloneKey,
        };

        return this.http.post<any>(`${this._url}` + '/clone', data);
    }

    getClientSubscriptionDetail(): Observable<ClientSubscriptionDetail[]> {
        return this.http.get<ClientSubscriptionDetail[]>(`${this._url}/detail`);
    }

    updateClientSubscription(subs: ClientSubscriptionDetailForm[]): Observable<any> {
        let data = {
            subscriptions: subs,
        };

        return this.http.post<any>(this._url + '/client/update', data);
    }

    createType(name: string, description: string): Observable<number> {
        const data = {
            name: name,
            description: description,
        };

        return this.http.post<number>(`${this._url}`, data);
    }

    editType(
        clientSubscriptionTypeKey: number,
        name: string,
        description: string,
        isActive: boolean
    ): Observable<number> {
        const data = {
            clientSubscriptionTypeKey: clientSubscriptionTypeKey,
            name: name,
            description: description,
            isActive: isActive,
        };

        return this.http.patch<number>(`${this._url}`, data);
    }
}

export interface ClientSubscriptionType {
    clientSubscriptionTypeKey: number;
    name: string;
    description: string;
    activeDate: Date;
    inActiveDate?: Date;
    isActive: boolean;
    lastMod?: Date;
    lastModUserKey?: number;
    nvLite: boolean;
}

export interface ClientSubscriptionPage {
    applicationPageKey: number;
    name: string;
    routerURL: string;
    hasPage: boolean;
    applicationPageTypeKey: number;
    parentApplicationPageKey?: number;
}

export interface ClientSubscriptionForm {
    applicationPageKey: number;
    clientSubscriptionTypeKey: number;
    isActive: boolean;
}

export interface ClientSubscriptionDetail {
    clientKey: number;
    clientFullName: string;
    clientShortName: string;
    clientSubscriptionKey?: number;
    clientSubscriptionTypeKey?: number;
    updated?: boolean;
}

export interface ClientSubscriptionDetailForm {
    clientKey: number;
    clientSubscriptionTypeKey: number;
    clientSubscriptionKey?: number;
}
